import { atom } from 'jotai'
import * as R from 'ramda'

import { selectorType } from '../@types/settings'
import {
  isJigens,
  isNotWeekDays,
  isWeekDays,
  ryoiki,
} from '../@types/timetable'
import {
  createTimeTableInitialObject,
  yureStringToGakkis,
  yureStringToGakunen,
  yureStringToYojigen,
} from '../utils'
import { excelState } from './excelState'
import { settingsState } from './settingsState'

type RyoikiAndNenji = {
  ryoikiIds: string[] | null
  nenjis: number[] | null
}

export const filterState = atom<RyoikiAndNenji>({
  ryoikiIds: null,
  nenjis: null,
})

type filterResultType = {
  filteredRows: string[][]
  table: ryoiki
  //
  ryoikiIds: string[]
}

// export const filterResultSelector = atom(get => {
//   get(filterS)
// })

export const filterResultSelector = atom(async get => {
  const { ryoikiIds, nenjis } = get(filterState)
  const { selector } = await get(settingsState)
  const sheetRecords = await get(excelState)
  // console.log('🍎1', ryoikiIds, nenjis)
  // console.log('🍎2', selector)
  // console.log('🍎3', sheetRecords)
  return new Promise<filterResultType>((resolve, reject) => {
    // const { ryoikiIds, nenjis } = get(filterState)

    if (ryoikiIds === null || nenjis === null) {
      // return {
      //   filteredRows: [],
      //   table: createTimeTableInitialObject(),
      //   ryoikiIds: [],
      // }
      resolve({
        filteredRows: [],
        table: createTimeTableInitialObject(),
        ryoikiIds: [],
      })
      return
    }
    // console.log('🍎4')
    // const { selector } = await get(settingsState)
    // const sheetRecords = await get(sheetState)
    // TODO: ここ確認
    // const sheetRecords = await get(excelState)
    const { specifiedList, ryoikiDatas } = getDataByRyoikis(ryoikiIds, selector)

    // 領域でフィルタ
    let filteredRows = sheetRecords.filter(record => {
      if (record.length > 0) {
        const kamokuBangou = record[0]
        if (kamokuBangou !== undefined) {
          // console.log(kamokuBangou)
          // 科目番号と前方一致
          for (let i = 0; i < ryoikiDatas.length; i++) {
            // console.log(
            //   kamokuBangou,
            //   ryoikiList[i],
            //   kamokuBangou.indexOf(ryoikiList[i])
            // )
            // if (kamokuBangou.indexOf(ryoikiDatas[i]) === 0) {

            if (kamokuBangou.indexOf(ryoikiDatas[i]) === 0) {
              return true
            }
          }
          // こちらはspecifiedと完全一致
          for (let j = 0; j < specifiedList.length; j++) {
            if (kamokuBangou === specifiedList[j]) {
              return true
            }
          }
        }
      }
      return false
    })

    // さらに学年でフィルタ
    filteredRows = filteredRows.filter(record => {
      const gakunen = yureStringToGakunen(record[4])
      for (let i = 0; i < gakunen.length; i++) {
        // if (nenjiList.includes(gakunen[i])) {
        if (nenjis.includes(gakunen[i])) {
          return true
        }
      }
      return false
    })

    const table: ryoiki = createTimeTableInitialObject()

    const duplicatedRows: string[][] = []
    filteredRows.forEach(record => {
      const splitedGakki = record[5].split('\n')
      const splitedJigen = record[6].split('\n')
      const multipleInstructions =
        splitedGakki.length > 1 || splitedJigen.length > 1
      if (multipleInstructions) {
        if (splitedGakki.length >= splitedJigen.length) {
          // 学期と時限が同じ数の場合は、それぞれを1レコード扱い
          // 学期が多い場合もそれぞれを1レコード扱い
          splitedGakki.forEach((gakki, index) => {
            const cloneRecord = R.clone(record)
            cloneRecord[5] = gakki
            cloneRecord[6] =
              splitedJigen[Math.min(splitedJigen.length - 1, index)] // 学期が2つあって曜日が1のときは両方1をつかう
            duplicatedRows.push(cloneRecord)
          })
        } else {
          // splitedJigen.forEach((jigen, index) => {
          //   const cloneRecord = R.clone(record)
          //   cloneRecord[6] = jigen
          //   cloneRecord[5] =
          //     splitedGakki[Math.min(splitedGakki.length - 1, index)]
          //   duplicatedRows.push(cloneRecord)
          // })
          // 学期よりも時限の改行が多い場合はまんま１レコード扱い
          duplicatedRows.push(record)
        }
      } else {
        duplicatedRows.push(record)
      }
    })

    duplicatedRows.forEach(record => {
      const gakkiList = yureStringToGakkis(record[5])
      // console.log('🍏', gakkiList)
      const yojigenList = yureStringToYojigen(record[6])
      // console.log('🍏🍏', yojigenList)
      gakkiList.forEach(gakki => {
        // console.log('🍎', gakki)
        // table[gakki]
        yojigenList.forEach(yojigen => {
          // console.log('🍋🍋🍋🍋', yojigen, R.head(yojigen))
          const strFirstChar = R.head(yojigen)
          // console.log('🍎🍏', strFirstChar)
          if (isWeekDays(strFirstChar)) {
            const jigen = Number(R.last(yojigen))
            if (isJigens(jigen)) {
              // console.log('🍑', gakki, strFirstChar, jigen, record)
              // console.log('🍑🍑🍑', gakki) // TODO: 夏季集中・通年はその他へ
              // TODO: jigenが随時・集中もその他へ

              if (gakki === 'その他') {
                // console.log('🍏そのたあああああああ', record)
                // table[gakki].push([record[0]])
                table[gakki].push(record)
              } else {
                // table[gakki][strFirstChar][jigen].push([
                //   record[0] + '\n' + record[1] + '\n',
                // ])
                table[gakki][strFirstChar][jigen].push(record)
              }
              // console.log('🔴', table[gakki][strFirstChar][jigen])
              // table[gakki][strFirstChar][jigen].push([
              //   record[0] + record[1] + '\n',
              // ])
              // table[gakki][strFirstChar][jigen].push(['🍎'])
              // table.春A['土']['6'].push(['⭐️'])
              // console.log('🐶', table)
            } else {
              console.log(
                jigen,
                '🍓🍓🍓🍓🍓🍓🍓🍓🍓🍓🍓🍓🍓🍓🍓🍓🍓🍓🍓🍓🍓何だこの数字は!!!!!!!!!'
              )
            }
            // if
            // console.log('🍎🍎曜日!!!', jigen)

            // table[gakki][strFirstChar].
          } else if (isNotWeekDays(strFirstChar)) {
            console.log('🍎🍏指定なし限定')
          } else {
            // console.log('🍏🍏随時とか')
            table.その他.push(record)
          }
          // consoleR.head(yojigen)
          // if (['月', '火', '水', '木', '金', '土'].includes(strFirstChar)) {
          //   // console.log('ようび！！')
          //   if (iswee)
          //   const y: weekType = R.head(yojigen)
          //   console.log(y)
          //   const j = yojigen[1]
          //   // table[gakki][]
          // } else {
          //   console.log('していなし！')
          // }
        })
      })
    })

    updateUrl(ryoikiIds, nenjis)

    // return {
    //   filteredRows,
    //   table,
    //   ryoikiIds,
    // }
    resolve({
      filteredRows,
      table,
      ryoikiIds,
    })

    // resolve({
    //   filteredRows: [],
    //   table: createTimeTableInitialObject(),
    //   ryoikiIds: [],
    // })
  })
})
// export const filterResultSelector2 = loadable(filterResultSelector)

const updateUrl = (ryoikis: string[], nenjis: number[]) => {
  // 一つも選択肢がなかったらひとまず0を入れておく
  // ここはURLで扱うのでtoLowerでOK
  const connectedRyoikiString =
    ryoikis.length > 0 ? R.toLower(ryoikis.join('_')) : '0'
  const nenjiHashStrings = nenjis.length > 0 ? nenjis.join('') : '0'
  const url = `#/${connectedRyoikiString}/${nenjiHashStrings}`
  window.location.replace(`${url}`)
}

const getDataByRyoikis = (ryoikis: string[], selector: selectorType[]) => {
  const ryoikiDatas: string[] = []
  const specifiedList: string[] = []
  ryoikis.forEach(urlRyoiki => {
    const filterdSelector = selector.filter(s => {
      return s.id === urlRyoiki
    })

    filterdSelector.forEach(r => {
      ryoikiDatas.push(...r.data)
      specifiedList.push(...r.specified)
    })
  })
  return { ryoikiDatas, specifiedList }
}

export const selectedRyoikis = atom(async get => {
  const { ryoikiIds } = get(filterState)
  const { selector } = await get(settingsState)

  return new Promise<selectorType[]>((resolve, reject) => {
    // console.log('🍊', ryoikiIds)

    const extractedItems = selector
      // .filter(item => ryoikiIds?.includes(R.toUpper(item.id)))
      .filter(item => ryoikiIds?.includes(item.id))
      .map(item => item)

    resolve(extractedItems)
  })
})

// export const selectedRyoikiLabels = selector<string[]>({
//   key: 'selectedRyoikiLabels',
//   get: ({ get }) => {
//     return R.pluck('label', get(selectedRyoikis))
//   },
// })

export const selectedRyoikiLabels = atom(async get => {
  const a = await get(selectedRyoikis)
  return R.pluck('label', a)
})
